import { render, staticRenderFns } from "./PrivilegesIndex.vue?vue&type=template&id=25b48dc7"
import script from "./PrivilegesIndex.vue?vue&type=script&lang=js"
export * from "./PrivilegesIndex.vue?vue&type=script&lang=js"
import style0 from "./PrivilegesIndex.vue?vue&type=style&index=0&id=25b48dc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports